import { humanizeCustomerPhoneNumber } from "@jugl-web/utils/utils/humanizeCustomerPhoneNumber";

const VOICE_CONV_ID_SUFFIX = "_voice";

export const formatVoiceConversationName = (convId: string): string => {
  const phoneNumber = convId.endsWith(VOICE_CONV_ID_SUFFIX)
    ? convId.slice(0, -VOICE_CONV_ID_SUFFIX.length)
    : convId;

  return humanizeCustomerPhoneNumber(phoneNumber) || phoneNumber;
};
